import { render, staticRenderFns } from "./MarkdownEditForm.vue?vue&type=template&id=2210e1f8&scoped=true&lang=pug&"
import script from "./MarkdownEditForm.vue?vue&type=script&lang=ts&"
export * from "./MarkdownEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./MarkdownEditForm.vue?vue&type=style&index=0&id=2210e1f8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2210e1f8",
  null
  
)

export default component.exports